export function makeUrl(sector, byValue, byGics) {
    const separator = "/"
    const sectorOrGics = !!sector ? separator + "sectors" + separator + sector : "";
    const byVolumeOrValue = separator + (!byValue ? "byVolume" : "byValue");
    const bySectorOrGics = !byGics ? "" : separator + "byGics";
    return "buyers-sellers" + sectorOrGics + byVolumeOrValue + bySectorOrGics;
}